export const generateCallID = () => {
  const mapping =
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const id = Array(23)
    .fill(0)
    .map(() => mapping[Math.floor(Math.random() * mapping.length)])
    .join('');

  return `call_${id}`;
};
